import React from "react";

import {
  FaFilter,
  FaSearch,
  FaUndoAlt,
} from "react-icons/fa";

import {
  TUTORIAL_SCOPE_OPTIONS,
  TUTORIAL_SORT_OPTIONS,
  TUTORIAL_STATUS_OPTIONS,
} from "../constants/tutorialAdminOptions";

const INPUT =
  "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-violet-400 focus:ring-4 focus:ring-violet-100 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100 dark:focus:ring-violet-900/40";

export default function TutorialFilters({
  search,
  onSearchChange,

  statusFilter,
  onStatusFilterChange,

  scopeFilter,
  onScopeFilterChange,

  sortBy,
  onSortChange,

  onReset,
}) {
  return (
    <section className="rounded-[26px] border border-slate-200/80 bg-white/95 p-5 shadow-[0_18px_50px_-24px_rgba(15,23,42,0.28)] dark:border-slate-800 dark:bg-slate-900/95 md:p-6">
      <div className="mb-5">
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-violet-500">
          <FaFilter />
          Filtres
        </div>

        <h2 className="mt-1 text-xl font-semibold text-slate-900 dark:text-slate-50">
          Rechercher un tutoriel
        </h2>

        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
          Filtre par application, site client, version ou
          statut de publication.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-3 xl:grid-cols-12">
        <div className="relative xl:col-span-5">
          <FaSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />

          <input
            type="search"
            className={`${INPUT} pl-11`}
            placeholder="Titre, application, site, version..."
            value={search}
            onChange={(event) =>
              onSearchChange(event.target.value)
            }
          />
        </div>

        <div className="xl:col-span-2">
          <select
            className={INPUT}
            value={statusFilter}
            onChange={(event) =>
              onStatusFilterChange(
                event.target.value
              )
            }
          >
            {TUTORIAL_STATUS_OPTIONS.map(
              (option) => (
                <option
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </option>
              )
            )}
          </select>
        </div>

        <div className="xl:col-span-2">
          <select
            className={INPUT}
            value={scopeFilter}
            onChange={(event) =>
              onScopeFilterChange(
                event.target.value
              )
            }
          >
            {TUTORIAL_SCOPE_OPTIONS.map(
              (option) => (
                <option
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </option>
              )
            )}
          </select>
        </div>

        <div className="xl:col-span-2">
          <select
            className={INPUT}
            value={sortBy}
            onChange={(event) =>
              onSortChange(event.target.value)
            }
          >
            {TUTORIAL_SORT_OPTIONS.map(
              (option) => (
                <option
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </option>
              )
            )}
          </select>
        </div>

        <div className="xl:col-span-1">
          <button
            type="button"
            onClick={onReset}
            className="inline-flex h-full min-h-[46px] w-full items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-slate-100 px-4 text-sm font-medium text-slate-700 transition hover:bg-slate-200 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
          >
            <FaUndoAlt />
            <span className="xl:hidden">
              Réinitialiser
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}